import { withSvgIcon } from './withSvgIcon';

export const TableViewIcon = withSvgIcon(
  <>
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V9C20 9.55228 19.5523 10 19 10H5C4.44772 10 4 9.55228 4 9V5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M4 15C4 14.4477 4.44772 14 5 14H19C19.5523 14 20 14.4477 20 15V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V15Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
